module.exports = __webpack_public_path__ + "img/idc_datacenter_pic03.42764fb8.jpg";